export const managerMenuLinks = [
    
    {
        "label": "menu.dashboard",
        "link": "/dashboard",
        "submenu": [
            {
                "label": "menu.welcomeDashboard",
                "link": "/dashboard/summary-dashboard"
            },
            {
                "label": "menu.mobileDevices",
                "link": "/dashboard/deviceslist/mobile-devices"
            },
            {
                "label": "menu.accessPoints",
                "link": "/dashboard/aps"
            },
        ]
    },
    {
        "label": "menu.settings",
        "link": "/settings",
        "dividerNeeded": true,
        "submenu": [
          {
            "label": "menu.subMenu.manageKiosks",
            "link": "/settings/manage-kiosk",
            // "dividerNeeded": true
          },
          {
            "label": "menu.subMenu.manageKioskDevice",
            "link": "/settings/kiosk-device",
            "dividerNeeded": true
          },
          {
            "label": "menu.subMenu.site",
            "link": "/settings/site",
            "dividerNeeded": true
          },
          {
            "label": "menu.subMenu.manageUsers",
            "link": "/settings/manage-users",
            "dividerNeeded": true
          },
        ]
    },
    {
        "label": "report.reports",
        "link": "/reports",
        "dividerNeeded": true,
        "submenu": [
            {
                "label": "devices",
                "link": "/reports/devices"
            },
            {
                "label": "report.historicalReports",
                "link": "/reports/historical-reports"
            },
            {
                "label": "report.eventsBySite",
                "link": "/reports/daily-event-detail-report"
            },
            {
                "label": "eodDeviceSummary",
                "link": "/reports/end-of-day-summary"
            }
        ]
    },
    {
        "label": "menu.about",
        "link": "/about",
        "dividerNeeded": true
    }

];

